import API from '@/services/API.ts';
import { authEndpoints } from '@/services/API.constants.ts';
import type {
  AuthenticateRequest,
  AuthenticateResponse,
  MfaExchangeRequest,
  MfaExchangeResponse,
  MfaResendRequest,
  MfaResendResponse,
} from '@/services/login.types';

export const submitAuthenticate = async (
  body: AuthenticateRequest,
): Promise<AuthenticateResponse> =>
  (await API.post<AuthenticateResponse>(authEndpoints.authenticate, body)).data;

export const submitMfaExchange = async (
  body: MfaExchangeRequest,
): Promise<MfaExchangeResponse> =>
  (await API.post<MfaExchangeResponse>(authEndpoints.mfaExchange, body)).data;

export const submitMfaResend = async (
  body: MfaResendRequest,
): Promise<MfaResendResponse> =>
  (await API.post<MfaResendResponse>(authEndpoints.mfaResend, body)).data;
